import Header from "../layout/Header";
import Footer from "../layout/Footer";
import { useNavigate } from "react-router-dom";
import SEO from "../SEO/SEO"


const AboutUsPage = () => {
  const navigate = useNavigate();
  const handleContact = () => navigate("/contact");
  const CTAButton = ({ children, ...props }) => (
    <button
      className="bg-[#00d9ff] hover:bg-cyan-400 text-[#002946] font-bold py-4 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
      {...props}
    >
      {children}
    </button>
  );
  return (
    <>
      <Header />
      <SEO
        title="About Us | Nexora Machinery"
        description="Learn about Nexora Machinery, a trusted supplier of CNC Turning Centers, VMC Machines, Milling Machines, Tapping Machines and industrial machinery."
        keywords="About Nexora Machinery, CNC Machine Supplier"
        path="/about"
      />
      <main className="mt-20">
        <section className="relative bg-gradient-to-br from-[#002946] via-[#004e7c] to-[#0066a5] text-white py-20 lg:py-28">
          <div className="absolute inset-0 bg-black/10"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
                About <span className="text-[#00d9ff]">Nexora</span>
              </h1>
              <p className="text-xl md:text-2xl text-blue-100 font-light mb-8">
                Powering the Next Generation of Industry
              </p>
              <div className="w-24 h-1 bg-[#00d9ff] mx-auto mb-8"></div>
            </div>
          </div>
        </section>
        <section className="py-16 lg:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
              <div className="space-y-8">
                <div>
                  <span className="text-[#00d9ff] font-semibold text-lg">WHO WE ARE</span>
                  <h2 className="text-3xl lg:text-4xl font-bold text-[#002946] mt-2 mb-6">
                    Innovating Industrial Excellence
                  </h2>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    Nexora Machinery brings global-standard industrial machinery
                    and equipment to local industries. With a focus on innovation, precision,
                    and reliability, we help businesses perform at their best.
                  </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-gradient-to-br from-[#002946] to-[#004e7c] text-white p-6 rounded-2xl shadow-xl">
                    <div className="w-12 h-12 bg-[#00d9ff] rounded-lg flex items-center justify-center mb-4">
                      <span className="text-2xl">🎯</span>
                    </div>
                    <h3 className="text-xl font-bold mb-3">Our Mission</h3>
                    <p className="text-blue-100">
                      Deliver modern, efficient, and durable machinery that empowers industries to grow and succeed.
                    </p>
                  </div>
                  <div className="bg-gradient-to-br from-[#00d9ff] to-[#0099cc] text-white p-6 rounded-2xl shadow-xl">
                    <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mb-4">
                      <span className="text-2xl">👁️</span>
                    </div>
                    <h3 className="text-xl font-bold mb-3">Our Vision</h3>
                    <p className="text-blue-50">
                      To be a leading machinery trading company globally, recognized for quality, integrity, and customer satisfaction.
                    </p>
                  </div>
                </div>
              </div>
              <div className="relative">
                <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
                  <img
                    src="/images/Nexora.png"
                    alt="Industrial machinery and equipment"
                    loading="lazy"
                    className="w-full h-auto object-cover transition-transform duration-700 hover:scale-105"
                  />
                </div>
                <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-[#00d9ff] rounded-2xl opacity-40"></div>
                <div className="absolute -top-6 -left-6 w-32 h-32 bg-[#002946] rounded-2xl opacity-40"></div>
              </div>
            </div>
          </div>
        </section>
        <section className="py-16 lg:py-6 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <span className="text-[#00d9ff] font-semibold text-lg">OUR SERVICES</span>
              <h2 className="text-3xl lg:text-4xl font-bold text-[#002946] mt-2">
                What We Offer
              </h2>
              <p className="text-gray-600 text-lg max-w-2xl mx-auto mt-4">
                Comprehensive solutions tailored to meet your industrial needs
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {[
                {
                  icon: "⚙️",
                  title: "High-quality Machinery",
                  description: "Industrial machinery and equipment built to last with global standards",
                  gradient: "from-blue-500 to-blue-700"
                },
                {
                  icon: "🔧",
                  title: "Tools & Spares",
                  description: "Complete range of tools, spares, and technical accessories",
                  gradient: "from-cyan-500 to-blue-600"
                },
                {
                  icon: "💡",
                  title: "Customized Solutions",
                  description: "Tailored solutions sourced from international manufacturers",
                  gradient: "from-blue-600 to-indigo-700"
                },
                {
                  icon: "🔧",
                  title: "After-Sales Support",
                  description: "Reliable maintenance and customer service for long-term satisfaction",
                  gradient: "from-cyan-600 to-blue-700"
                }
              ].map((service, index) => (
                <div
                  key={index}
                  className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
                >
                  <div className={`w-16 h-16 bg-gradient-to-br ${service.gradient} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <span className="text-2xl">{service.icon}</span>
                  </div>
                  <h3 className="text-xl font-bold text-[#002946] mb-4">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                  <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#00d9ff] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="py-16 lg:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
              <div className="order-2 lg:order-1">
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-4">
                    <div className="bg-gradient-to-br from-[#002946] to-[#004e7c] rounded-2xl aspect-square"></div>
                    <div className="bg-gradient-to-br from-[#00d9ff] to-[#0099cc] rounded-2xl aspect-video"></div>
                  </div>
                  <div className="space-y-4 mt-8">
                    <div className="bg-gradient-to-br from-gray-200 to-gray-300 rounded-2xl aspect-video"></div>
                    <div className="bg-gradient-to-br from-[#002946] to-[#003358] rounded-2xl aspect-square"></div>
                  </div>
                </div>
              </div>
              <div className="order-1 lg:order-2">
                <span className="text-[#00d9ff] font-semibold text-lg">WHY CHOOSE US</span>
                <h2 className="text-3xl lg:text-4xl font-bold text-[#002946] mt-2 mb-8">
                  Excellence in Every Partnership
                </h2>
                <div className="space-y-6">
                  {[
                    "Trusted network of global suppliers",
                    "Competitive pricing with quality assurance",
                    "Fast and secure logistics",
                    "Long-term partnership commitment",
                    "Technical expertise and consultation",
                    "Sustainable and innovative solutions"
                  ].map((item, index) => (
                    <div key={index} className="flex items-start space-x-4 group">
                      <div className="w-8 h-8 bg-[#00d9ff] rounded-full flex items-center justify-center flex-shrink-0 mt-1 group-hover:scale-110 transition-transform duration-300">
                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                        </svg>
                      </div>
                      <p className="text-gray-700 text-lg font-medium group-hover:text-[#002946] transition-colors duration-300">
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
                <div className="grid grid-cols-2 gap-6 mt-12">
                  <div className="text-center">
                    <div className="text-3xl lg:text-4xl font-bold text-[#002946]">50+</div>
                    <div className="text-gray-600">Global Partners</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl lg:text-4xl font-bold text-[#002946]">1000+</div>
                    <div className="text-gray-600">Projects Completed</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="py-16 bg-gradient-to-r from-[#002946] to-[#004e7c] text-white">
          <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl lg:text-4xl font-bold mb-6">
              Ready to Transform Your Industry?
            </h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              Partner with us for cutting-edge machinery solutions that drive growth and efficiency.
            </p>
            <CTAButton onClick={handleContact}>
              Get In Touch
            </CTAButton>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default AboutUsPage;